export const EXPECTED_COLUMNS = [
    "[Club] Name",
    "[Club] Subdomain",
    "[Area] Subdomain",
    "# members",
    "[Bank Account] Name",
    "[Bank Account] IBAN",
    "[Bank Account] BIC",
    "[Bank Account] Owner",
    "[FinOrg] Name",
    "[FinOrg] Street1",
    "[FinOrg] Street2",
    "[FinOrg] Postal Code",
    "[FinOrg] City",
    "[Treasurer] Name",
    "[Treasurer] Street1",
    "[Treasurer] Street2",
    "[Treasurer] Postal Code",
    "[Treasurer] City",
    "[Treasurer] Email"
];

export interface ColumnValidationResult {
    isValid: boolean;
    missingColumns: string[];
    extraColumns: string[];
}

/**
 * Validates that the data contains all expected columns and no extra columns
 * @param data - Array of data records to validate
 * @returns Validation result with missing and extra columns
 */
export const validateColumns = (data: Record<string, any>[]): ColumnValidationResult => {
    if (data.length === 0) {
        return { isValid: true, missingColumns: [], extraColumns: [] };
    }

    // Collect all unique keys from all data rows
    const actualColumnsSet = new Set<string>();
    data.forEach(row => {
        Object.keys(row).forEach(key => actualColumnsSet.add(key));
    });
    const actualColumns = Array.from(actualColumnsSet);

    const missingColumns = EXPECTED_COLUMNS.filter(col => !actualColumns.includes(col));
    const extraColumns = actualColumns.filter(col => !EXPECTED_COLUMNS.includes(col));

    return {
        isValid: missingColumns.length === 0 && extraColumns.length === 0,
        missingColumns,
        extraColumns
    };
};
